<template>
  <strong class="live-wait-time">{{ display }}</strong>
</template>

<script>
import { formatWait, crossedIntoOrange } from '@/utils/kitchenWaitCounter'
import { primeKitchenWaitAudio, playOrangeTone } from '@/utils/kitchenWaitAudio'
import { DELIVERY_TEXTS } from '../deliveryConstants'
import { WAIT_STATE, LOCAL_TICK_MS, MILLISECONDS_PER_SECOND } from '../kitchenWaitConstants'

export default {
  name: 'DealerWaitCounter',
  props: {
    route: {
      type: Object,
      required: true
    },
    serverNow: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      elapsedSeconds: 0,
      receivedAt: Date.now(),
      tick: null
    }
  },
  computed: {
    baseSeconds () {
      return this.route.wait_seconds
    },
    isWaiting () {
      return this.route.state === WAIT_STATE.WAITING
    },
    isDeparted () {
      return this.route.state === WAIT_STATE.STARTED
    },
    hasTime () {
      return this.isWaiting || (this.isDeparted && this.baseSeconds !== null && this.baseSeconds !== undefined)
    },
    displaySeconds () {
      if (!this.isWaiting) {
        return this.baseSeconds
      }

      return this.baseSeconds + this.elapsedSeconds
    },
    display () {
      return this.hasTime ? formatWait(this.displaySeconds) : DELIVERY_TEXTS.EMPTY_CELL
    }
  },
  watch: {
    'route.state' () {
      this.syncTick()
    },
    serverNow () {
      this.receivedAt = Date.now()
      this.elapsedSeconds = 0
    },
    displaySeconds: {
      immediate: true,
      handler (seconds) {
        this.$emit('seconds-change', this.route.route_id, seconds)
      }
    }
  },
  mounted () {
    primeKitchenWaitAudio()
    this.syncTick()
  },
  beforeDestroy () {
    this.clearTick()
  },
  methods: {
    syncTick () {
      if (this.isWaiting && !this.tick) {
        this.receivedAt = Date.now()
        this.tick = setInterval(this.advance, LOCAL_TICK_MS)
        return
      }
      if (!this.isWaiting) {
        this.clearTick()
      }
    },
    advance () {
      const previous = this.displaySeconds
      this.elapsedSeconds = Math.max(0, Math.floor((Date.now() - this.receivedAt) / MILLISECONDS_PER_SECOND))

      if (crossedIntoOrange(previous, this.displaySeconds)) {
        playOrangeTone()
      }
    },
    clearTick () {
      if (this.tick) {
        clearInterval(this.tick)
        this.tick = null
      }
    }
  }
}
</script>
